import { normalizeInputTypes } from '../model/Input';
import type { SkillData } from '../spacetime/modules/SkillModule';
import type { CodexTab } from './codexShared';

export interface CodexPickerRequest {
  tab: CodexTab;
  title: string;
}

const CODEX_PICKER_BY_SKILL_ID: Record<string, CodexPickerRequest> = {
  summon_zombie: {
    tab: 'mobs',
    title: 'Select Mob to Summon',
  },
  disguise: {
    tab: 'appearances',
    title: 'Select Disguise Appearance',
  },
};

export function getCodexPickerRequest(skill: SkillData): CodexPickerRequest | null {
  const inputTypes = normalizeInputTypes(skill.inputsJson);
  if (!inputTypes.includes('text')) {
    return null;
  }
  return CODEX_PICKER_BY_SKILL_ID[skill.skillId] ?? null;
}
